import React, {useEffect, useState} from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { Row, Col, Input } from "antd";

interface LocationInputProps {
  value?: ILocation;
  size?: number; // column size
  onChange?: (value: ILocation) => void;
  placeholder?: string;
}

const LocationInput: React.FC<LocationInputProps> = ({
  value = null,
  size = 18,
  placeholder,
  onChange,
}) => {
  const [address, setAddress] = useState(value?.attributes?.address || null);

  useEffect(() => {}, [address]);
  const [location, setLocation] = useState<ILocation>(
    value || {
      coordinates: {
        lat: 0,
        long: 0,
      },
      attributes: {
        address: "",
        zip: "",
        stAddressOne: "",
        stAddressTwo: "",
        city: "",
        state: "",
        country: "",
      },
    }
  );
  const setLocationInfo = (locationData: any) => {
    const getLocationData: ILocation = {
      coordinates: {
        lat: 0,
        long: 0,
      },
      attributes: {
        address: "",
        zip: "",
        stAddressOne: "",
        stAddressTwo: "",
        city: "",
        state: "",
        country: "",
      },
    };
    for (const address_component of locationData[0].address_components) {
      if (address_component.types.includes("postal_code")) {
        getLocationData.attributes.zip = address_component.short_name || "";
      } else if (
        address_component.types.includes("locality") ||
        address_component.types.includes("sublocality_level_1")
      ) {
        getLocationData.attributes.city = address_component.short_name;
      } else if (
        address_component.types.includes("administrative_area_level_1")
      ) {
        getLocationData.attributes.state = address_component.short_name;
      } else if (address_component.types.includes("country")) {
        getLocationData.attributes.country = address_component.long_name;
      }
    }

    getLocationData.attributes.address = locationData[0].formatted_address;
    getLocationData.coordinates = {
      lat: locationData[0].geometry.location.lat(),
      long: locationData[0].geometry.location.lng(),
    };

    onChange(getLocationData);
    setLocation(getLocationData);
  };

  return (
    <div>
      <Row className="datetime-item">
        <GooglePlacesAutocomplete
          selectProps={{
            value: address,
            onChange: (place: any) => {
              if (place?.value) {
                setAddress(place);
                geocodeByPlaceId(place.value.place_id)
                  .then((results) => {
                    if (results[0]?.address_components) {
                      setLocationInfo(results);
                    }
                  })
                  .catch((error) => console.error(error));
              }
            },
            isClearable: false,
            placeholder: placeholder,
            styles: {
              input: (provided: any) => ({
                ...provided,
                fontFamily: "Nunito-Regular",
              }),
              control: () => ({
                backgroundColor: "transparent",
                display: "flex",
              }),
              container: (provided, state) => ({
                ...provided,
                width: "100%",
                background: "transparent",
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#000",
                fontSize: 16,
                padding: 8,
              }),
              singleValue: (provided, state) => ({
                ...provided,
                color: "#000",
                fontSize: 16,
                padding: 8,
              }),
            },
          }}
          apiKey={"AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"}
        />
      </Row>
      <Row>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.stAddressOne}
            placeholder="Street Address One"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  stAddressOne: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.stAddressTwo}
            placeholder="Street Address Two"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  stAddressTwo: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.zip}
            placeholder="Enter Zip Code"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  zip: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.city}
            placeholder="City"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  city: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.state}
            placeholder="State"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  state: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
        <Col span={8} className="location-item pr-2 mt-2" xs={24} sm={8}>
          <Input
            value={location.attributes.country}
            placeholder="Country"
            onChange={(e) => {
              setLocation({
                coordinates: { ...location.coordinates },
                attributes: {
                  ...location.attributes,
                  country: e.target.value,
                },
              });
              onChange(location);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default LocationInput;
